<template>
  <template v-for="doc in docs" :key="getRelationshipID(doc)">
    <slot :doc="doc" name="doc" />
  </template>
  <template v-if="loading">
    <slot
      v-for="n in props.collection?.limit || 6"
      :key="n"
      name="placeholder"
    />
  </template>
  <template v-if="showButton">
    <CollapsibleWrapper class="col-span-full" :collapse="!showButton" fade>
      <div class="pt-10 text-center md:pt-16 xl:pt-20">
        <BaseButton class="btn-sm btn-black" @click="emit('loadMore')">
          <slot name="button-label">Load more</slot>
        </BaseButton>
      </div>
    </CollapsibleWrapper>
  </template>
</template>

<script setup lang="ts" generic="T extends { id: string }">
import type { PaginatedDocs } from 'payload/database'

interface PayloadLoadMoreWrapperProps {
  collection: PaginatedDocs<T> | null | undefined
  loading?: boolean
}

const props = withDefaults(defineProps<PayloadLoadMoreWrapperProps>(), {
  collection: null,
  loading: false,
})
const emit = defineEmits(['loadMore'])

const docs = computed(() => props.collection?.docs || [])

const showButton = computed(() =>
  props.collection?.page
    ? props.collection.page < props.collection.totalPages
    : false,
)
</script>
